import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/junglebet/images/mb-logo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 2,
    alignItems: 'center',
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'solid', px: '2' },
  imageLogo: {
    w: '170px',
    src: mysteryLogo,
  },
  iconMystery: {},
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow: 'sm',
    px: '3',
    color: 'white',
    overflow: 'hidden',
    mx: 'auto',
    fontSize: 'sm',
  },
  flexWrapperMysteryPlacedBetView: {},
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    w: 'auto',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow: 'sm',
    p: '2',
    mx: '4',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    w: 'auto',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
    mx: '4',
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bgGradient: 'linear-gradient(to-b, beta.400, beta.600)',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
    borderRadius: 'md',
    border: '2px solid',
    boxSize: '34px',
    p: '2',
    color: 'beta.300',
    cursor: 'pointer',
  },
  imageMysteryBet: {
    w: '5',
    color: 'red',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
  },
  textPriceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'beta.500',
    fontWeight: 'bold',
  },
  textRollover: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'beta.500',
    fontWeight: 'bold',
  },
  textError: {
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  iconBack: {
    boxSize: '10',
    color: 'beta.500',
  },
  iconRace: { color: 'beta.400' },
  textSpanWhite: {
    color: 'white',
  },
  buttonGroupAddToBetslip: {
    mr: '2',
    alignItems: 'center',
  },
  tooltipIcon: {
    fill: 'orange.700',
    border: 'none',
    boxSize: '4',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
  },
  buttonAddToBetslip: {
    variant: 'secondary',
    fontFamily: 'CarterOne',
  },
  buttonRollOver: {
    variant: 'solid',
  },
  flexWrapperMysteryLabelView: {
    fontWeight: 'bold',
    fontSize: 'xs',
  },
};
